// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__17tfS"};
    if(module.hot) {
      // 1586964021068
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  